export interface Location {
  name: string;
  type: string;
  lat: number;
  lng: number;
  address: string;
  url: string;
  icon: string;
}

export const venueLocations: Location[] = [
  {
    name: "Saint Albert the Great Catholic Church",
    type: "Ceremony",
    lat: 30.403037,
    lng: -97.699077,
    address: "12041 Bittern Hollow, Austin, TX 78758",
    url: "https://maps.app.goo.gl/8wGkW1V9MFRM6Lsp6",
    icon: "✝️"
  },
  {
    name: "Springdale Station",
    type: "Reception",
    lat: 30.262376,
    lng: -97.696695,
    address: "979 Springdale Rd Suite #160, Austin, TX 78702",
    url: "https://maps.app.goo.gl/SCWVf76J9duhJ97w6",
    icon: "🎉"
  },
  {
    name: "Hampton Inn Austin NW",
    type: "Hotel Block",
    lat: 30.39719,
    lng: -97.73481,
    address: "3908 W. Braker Ln, Austin, TX 78759",
    url: "https://maps.app.goo.gl/b5vyrwPr6z7tiKYp6",
    icon: "🏨"
  },
  {
    name: "Hampton Inn Austin East Side",
    type: "Hotel Block",
    lat: 30.26234,
    lng: -97.71486,
    address: "2033 E. 5th Street, Austin, TX 78702",
    url: "https://www.google.com/maps/place/Hampton+Inn+Austin+East+Side+5th+Street/@30.26234,-97.71486,17z",
    icon: "🏨"
  },
  {
    name: "Our House - Sunday BBQ",
    type: "Day After BBQ",
    lat: 30.36314,
    lng: -97.66106,
    address: "2405 Sisterdale Lane, Austin, TX 78754",
    url: "https://maps.app.goo.gl/eUnnPyREy2JMKYJd8",
    icon: "🏠"
  }
];
